<div class="flex-shrink-0 sticky top-0 bg-white dark:bg-slate-700 z-10 p-4">
  <div class="flex flex-row justify-between items-center">
    @if (showBackButton) {
    <div class="mr-4">
      <button mat-icon-button (click)="onMoveBack()">
        <mat-icon>arrow_back</mat-icon>
      </button>
    </div>
    }
    <h2 class="text-3xl sm:text-xl font-semibold">{{ title }}</h2>
    @if (showCloseButton) {
      <button mat-icon-button (click)="onCloseDrawer()">
        <mat-icon class="close-button">close</mat-icon>
      </button>
    } @else {
      <div>&nbsp;</div>
    }
  </div>
  <div>
    <ng-content></ng-content>
  </div>
</div>
